import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"

i18n.use(initReactI18next)
.use(LanguageDetector)
.use(Backend)
.init({
    supportedLngs: ['fr', 'es', 'pt'],
    localeDetection: true,
    detection: {
        order: [
            'queryString',
            'subdomain',
            'cookie',
            'localStorage',
            'navigator',
            'htmlTag',
            'path',
        ],
        caches: ['cookie'],
        lookupQuerystring: 'lng',
    },
    fallbackLng:"fr",
    domains: [{
        domain: "pass.onair-fitness.es",
        defaultLocale: "es",
    }, {
        domain: "pass.onair-fitness.fr",
        defaultLocale: "fr",
    }, {
        domain: "pass.onair-fitness.pt",
        defaultLocale: "pt",
    }]
});
window.i18n = i18n;